import { render, staticRenderFns } from "./c-view_itens.vue?vue&type=template&id=4313244a"
import script from "./c-view_itens.vue?vue&type=script&lang=js"
export * from "./c-view_itens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports